const footerDataArabic = {
    description: "كل الحقوق محفوظة لشركة شركه سبل الاعمال لتكييف الهواء",
    TermsPage: "شروط",
    PrivacyPage: "خصوصية"
}

export { footerDataArabic }